<div class="header-container">
  <div class="logo-container cursor-pointer">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle d-lg-none d-md-block">
      <nb-icon icon="menu-2-outline" class="text-white"></nb-icon>
    </a>
    <span class="logo border-0 p-0" style="color: #d2dbed">
      <!-- <img src="assets/images/loader.svg" height="60" class="mr-2">&emsp; -->
      <img
        src="assets/images/loader.svg"
        height="40"
        class="mr-2 py-sm-2 py-md-0 mt-1"
      />&emsp;
      <h4
        class="d-inline-block ml-2 pl-2 d-md-none"
        style="font-variant: small-caps; padding-left: 1.5rem;     font-weight: 300;"
      >
        gitten
      </h4>
    </span>
    <small class="d-sm-inline-block d-md-none"
      ><i class="fa fa-link"></i> Web</small
    >
  </div>
</div>
<div class="header-container">
  <nb-actions size="small">
<!--     <nb-action>
      <a
        class="btn btn-light"
        href="https://github.com/VincenzoManto"
        rel="noopener"
        target="_blank"
        aria-label="Follow @VincenzoManto on GitHub"
      >
        <i class="fab fa-github"></i>&nbsp;&nbsp;<span>Follow me</span>
      </a>
    </nb-action> -->
    <nb-action class="d-lg-block d-md-none">
      <a
        class="btn btn-light rounded-pill"
        href="https://github.com/VincenzoManto/Docusighter/generate"
        rel="noopener"
        target="_blank"
        aria-label="Use this template Docusighter on GitHub"
        ><svg
          viewBox="0 0 16 16"
          width="16"
          height="16"
          class="octicon octicon-repo-template"
          aria-hidden="true"
        >
          <path
            d="M13.25 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-.75a.75.75 0 0 1 0-1.5h.75v-.25a.75.75 0 0 1 .75-.75ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2ZM2.75 8a.75.75 0 0 1 .75.75v.268c.083-.012.166-.018.25-.018h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.75c0 .28.114.532.3.714a.75.75 0 1 1-1.05 1.072A2.495 2.495 0 0 1 2 11.5V8.75A.75.75 0 0 1 2.75 8ZM11 .75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V1.5h-.75A.75.75 0 0 1 11 .75Zm-5 0A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 .75Zm0 9A.75.75 0 0 1 6.75 9h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 6 9.75ZM4.992.662a.75.75 0 0 1-.636.848c-.436.063-.783.41-.846.846a.751.751 0 0 1-1.485-.212A2.501 2.501 0 0 1 4.144.025a.75.75 0 0 1 .848.637ZM2.75 4a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 2.75 4Zm10.5 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75Z"
            fill="#fff"
          ></path></svg>&nbsp;<span>Use this template</span></a>
    </nb-action>
    <nb-action class="control-item hideable">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
<!--     <nb-action
      class="control-item hideable"
      [badgeText]="githubService.events.length"
      badgeStatus="success"
      badgePosition="top right"
    >
      <nb-icon icon="bell-outline"></nb-icon>
    </nb-action> -->
    <nb-action
      class="user-action mr-1 cursor-pointer d-lg-block d-md-none"
      (click)="openTemplate(config)"
    >
      <nb-icon icon="settings-2-outline"></nb-icon>
    </nb-action>
    <nb-action class="user-action mr-1 cursor-pointer">
        <a [routerLink]="'/pages/charts'">
        <nb-icon icon="bar-chart-outline"></nb-icon>
      </a>
      </nb-action>
    <nb-action class="user-action"       [badgeText]="githubService.events.length"
    badgeStatus="success"
    badgePosition="bottom right">
      <img
        referrerpolicy="no-referrer"
        class="user-picture"
        [src]="user?.avatar_url"
      />
      <nb-user
        [nbContextMenu]="userMenu"
        [onlyPicture]="false"
        title="Pro"
        [name]="user?.name"
        [picture]="user?.avatar_url"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<ng-template #config let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Configuration</nb-card-header>
    <nb-card-body class="overflow-y-auto h-fit pb-4">
      <div class="row">
        <div class="col-12">
          <div
            class="row align-items-center bottom-border mb-2"
            *ngFor="let entry of markdownInstance?.config | keyvalue"
          >
            <div class="col-16 col-md-6">
              {{ entry.key | titlecasesplit }}
            </div>
            <div class="col-16 col-md-6">
              <input
                nbInput
                fullWidth
                placeholder="Enter value"
                [ngModel]="entry.value"
                (ngModelChange)="markdownInstance.config[entry.key] = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer
      class="position-absolute w-100 bottom-0 d-flex justify-content-between"
    >
      <button class="btn rounded-pill" (click)="ref.close()">
        <i class="fas fa-times"></i> Close
      </button>
      <button
        class="btn rounded-pill active"
        (click)="saveConfig(); ref.close()"
      >
        <i class="fas fa-check"></i> Save
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
